<template>
    <div>
      <!--Modal de informações-->
      <vuestic-modal :show.sync="modal.show" ref="smallModal" v-bind:small="false" :cancelClass="'none'" okText="Fechar" cancelText="Fechar">
            <div slot="title">Informações</div>

            <div v-show="modal.load" >
                <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                    <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                        <component
                                :animation-duration="1000"
                                :is="'SpringSpinner'"
                                :color="'#4AE387'"
                                :size="80"
                        >
                        </component>
                    </div>
                </div>
            </div>
            <div v-show="!modal.load">
              <vuestic-tabs :names="['Dados Básicos']" ref="tabs">
                <div slot="Dados Básicos">
                  <div class="row">
                    <div class="col-md-8 row-break">
                      <strong class="font-weight-bold">Nome:</strong><br>
                      <span class="circle badge-success" v-if="modal.conteudo.flg_ativo"></span>
                      <span class="circle badge-danger" v-if="!modal.conteudo.flg_ativo"></span>
                      {{modal.conteudo.nome}}
                    </div>

                    <div class="col-md-4">
                      <strong class="font-weight-bold">AutoEscola:</strong><br>
                      <template v-if="modal.conteudo.schema !== 'public'">{{modal.conteudo.schema}}</template>
                      <template v-else>Monitoramento</template>
                    </div>
                  </div>
                  <br>
                  <div class="row">
                    <div class="col-md-4">
                      <strong class="font-weight-bold">CPF:</strong><br>
                      {{modal.conteudo.cpf}}
                    </div>

                    <div class="col-md-4">
                      <strong class="font-weight-bold">Data de Nascimento:</strong><br>
                      <strong v-if="modal.conteudo.data_nascimento == null" style="margin-left: 60px;">-</strong>
                      <strong v-else style="margin-left: 30px;">{{modal.conteudo.data_nascimento | DateBRFilter}}</strong>
                    </div>

                    <div class="col-md-4">
                      <strong class="font-weight-bold">Telefone:</strong><br>
                      {{modal.conteudo.telefone}}
                    </div>
                  </div>
                  <br>
                  <div class="row">
                    <div class="col-md-12 row-break">
                      <strong class="font-weight-bold">E-mail:</strong><br>
                      {{modal.conteudo.email}}
                    </div>
                  </div>
                  <!--<strong>Situação:</strong>-->
                </div>
              </vuestic-tabs>
            </div>
        </vuestic-modal>

      <vuestic-modal :show.sync="modal.show" ref="fileModal" v-bind:small="false" cancelClass="none" okClass="none">
        <vuestic-tabs :names="['PDF', 'XLSX']" ref="tabs">
          <div slot="PDF">
            <div class="row justify-content-center">
              <div v-if="downloadPDFLoading" class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="55"></component>
                </div>
              </div>
              <button v-else class="btn btn-primary" @click="downloadFilePDF" :disabled="downloadPDFLoading">Download PDF</button>
            </div>
          </div>

          <div slot="XLSX">
            <div class="row justify-content-center">
              <div v-if="downloadXLSXLoading" class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="55"></component>
                </div>
              </div>

              <button v-else class="btn btn-primary" @click="downloadFileXLSX">Download XLSX</button>
            </div>
          </div>
        </vuestic-tabs>
      </vuestic-modal>

      <template v-if="!loaded">
        <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
          <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
              <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
          </div>
        </div>
      </template>

      <template v-else>
        <!--Legenda com barra de pesquisa-->
        <div class="row">
          <div class="col-md-3">
            <button class="btn btn-micro btn-info seachButtons" @click="openModal">
              <i class="fa fa-download"></i>
              Relátorio
            </button>
          </div>
        </div>
        <!--Legenda com barra de pesquisa-->

        <form class="row mt-3 mb-5 form" @submit.prevent="handleConsult">
          <fieldset class="col-md-3 inputs" id="nome">
            <legend>Nome</legend>
            <input type="text" class="form-control pl-2 border rounded" id="nome_aluno" v-model="inputs.name" placeholder="Nome" />
          </fieldset>

          <fieldset class="col-md-3" id="nome">
            <legend>CPF</legend>
            <the-mask class="form-control pl-2 border rounded" :mask="'###.###.###-##'" v-model="inputs.cpf" id="cpf_aluno" placeholder="000.000.000-00" />
          </fieldset>

          <fieldset class="col-md-3 inputs">
            <legend>Função</legend>
            <model-select :options="selectRoles" v-model="inputs.role" placeholder="Função">
              <option>Selecione uma função</option>
            </model-select>
          </fieldset>

          <fieldset class="col-md-3 inputs">
            <legend>Status</legend>
            <model-select :options="selectStatus" v-model="inputs.status" placeholder="Status"></model-select>
          </fieldset>

          <fieldset class="col-md-3" id="inicioProcesso">
            <legend>Período inicial</legend>
            <input type="date" class="form-control border rounded pl-2 pr-2" v-model="inputs.initialPeriod" />
          </fieldset>

          <fieldset class="col-md-3" id="inicioProcesso">
            <legend>Período final</legend>
            <input type="date" class="form-control border rounded pl-2 pr-2" v-model="inputs.finalPeriod" />
          </fieldset>

          <div class="col-md-3 d-flex align-items-end">
						<button type="submit" class="btn btn-block btn-micro btn-info mb-3 seachButtons" :disabled="table.load">
							<template v-if="table.load">
                <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                  <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                      <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="17"></component>
                  </div>
                </div>
              </template>

              <template v-else>
                <i class="fa fa-search"></i>
							  Consultar
              </template>
						</button>
					</div>

          <div class="col-md-3 d-flex align-items-end">
						<button type="button" class="btn btn-block btn-micro btn-danger mb-3 seachButtons" :disabled="table.load" @click="clearInputs">
							<template v-if="table.load">
                <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                  <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                      <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="17"></component>
                  </div>
                </div>
              </template>

              <template v-else>
                <i class="fa fa-trash"></i>
							  Limpar
              </template>
						</button>
					</div>

          <div class="col-md-3 d-flex align-items-center mb-2 mt-3">
            <div class="mr-3 d-flex align-items-center"><span class="circle badge-success mr-2"></span> Ativos</div>
            <div class="d-flex align-items-center"><span class="circle badge-danger mr-2"></span> Inativos</div>
          </div>
        </form>

        <!--Botões da paginação-->
        <div class="row" v-if="consulted">
          <div class="col mx-auto">
            <pagination :source="pagination" @navigate="navigate" class="pagination justify-content-center"></pagination>
          </div>
        </div>
        <!--Botões da paginação-->

        <!--Tabela-->
        <div class="row" v-if="consulted">
            <div class="col-md-12">
                <table class="table table-striped table-bordered table-responsive-sm text-center">
                    <thead>
                      <tr>
                        <th v-for="th in tableOptions.thead" :key="th">
                          {{th}}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="table.load" >
                        <td colspan="7" class="text-center">
                          <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                            <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                                <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr v-else v-for="dados in table.data" :key="'usuarios_'+dados.cpf+'_'+dados.id_usuario" class="tb-linha">
                        <td class="status-badge">
                          <span class="circle badge-success" v-if="dados.flg_ativo"></span>
                          <span class="circle badge-danger" v-if="!dados.flg_ativo"></span>
                        </td>
                        <td v-if="dados.schema !== 'public'">{{ dados.nome_fantasia }}</td>
                        <td v-else>Monitoramento</td>
                        <td>{{ utils.formatarCPF(dados.cpf) }}</td>
                        <td>{{ dados.nome }}</td>
                        <td>{{ dados.funcao_usuario }}</td>
                        <td>{{ utils.formatOnlyDate(dados.data_criacao) }}</td>
                        <td>
                          <div class="buttons-td">
                            <button title="Desativar usuário" class="action-button" v-if="dados.flg_ativo" @click="atualizaStatus(dados.id_usuario, 'desativar')">
                              <i class="fa fa-lock"></i>
                            </button>

                            <button title="Ativar usuário" class="action-button" v-if="!dados.flg_ativo" @click="atualizaStatus(dados.id_usuario, 'ativar')">
                              <i class="fa fa-unlock"></i>
                            </button>

                            <button title="Ver informações do usuário" class="action-button" @click="detalhes(dados.id_usuario)">
                              <i class="fa fa-info"></i>
                            </button>

                            <button title="Atualizar usuário" class="action-button" :disabled="!dados.flg_ativo" @click="paginaEdicao(dados.id_usuario)">
                              <i class="fa fa-edit"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr v-show="table.data.length === 0 && !table.load">
                          <td colspan="7" class="text-center">Nenhum registro encontrado.</td>
                      </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!--Tabela-->

        <!--Botões da paginação-->
        <div class="row" v-if="consulted">
          <div class="col mx-auto">
            <pagination :source="pagination" @navigate="navigate" class="pagination justify-content-center"></pagination>
          </div>
        </div>
        <!--Botões da paginação-->
      </template>
    </div>
</template>

<script>
import UsuariosController from './UsuariosController'
import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
import * as spinners from 'epic-spinners'
import urlApiV2 from '../../router/urlApiV2'
import utils from '../../services/utils'
import pagination from '../pagination/pagination'
import _ from 'lodash'
import { ModelSelect } from 'vue-search-select'
import { TheMask } from 'vue-the-mask'

window._ = require('lodash')

export default {
  name: 'TableUsuarios',
  components: {
    ...spinners,
    DateIconGroup,
    pagination,
    ModelSelect,
    TheMask,
  },
  data () {
    return {
      inputs: {
        name: '',
        cpf: '',
        role: '',
        status: '',
        initialPeriod: '',
        finalPeriod: '',
      },
      selectRoles: [],
      selectStatus: [
        {
          value: 'active',
          text: 'Ativo',
        },
        {
          value: 'inactive',
          text: 'Inativo',
        },
      ],
      modal: {
        show: false,
        load: false,
        conteudo: {}
      },
      tableOptions: { 'thead': ['#', 'Auto Escola', 'CPF', 'nome', 'Função', 'Data de Criação', 'Ações'] },
      consult: '',
      filters: '',
      table: {
        currentPage: '',
        data: '',
        firstPageUrl: '',
        from: '',
        lastPage: '',
        lastPageUrl: '',
        nextPageUrl: '',
        path: '',
        perPage: '',
        prevPageUrl: '',
        to: '',
        total: '',
        pages: [],
        load: false
      },
      utils: utils,
      pagination: '',
      loaded: false,
      downloadPDFLoading: false,
      downloadXLSXLoading: false,
      consulted: false,
    }
  },
  async mounted () {
    await this.loadRoles()

    this.loaded = true
  },
  methods: {
    clearInputs () {
      this.inputs = {
        name: '',
        cpf: '',
        role: '',
        status: '',
        initialPeriod: '',
        finalPeriod: '',
      }
      this.filters = ''
    },
    async handleConsult () {
      this.inputs.cpf = this.inputs.cpf ? this.inputs.cpf.replaceAll('.', '').replaceAll('-', '') : ''
      this.inputs.role = this.inputs.role ? this.inputs.role : ''
      this.inputs.status = this.inputs.status ? this.inputs.status : ''

      await this.loadData()
    },
    navigate (page) {
      this.table.load = true
      this.$http.get(`${this.consult}&page=${page}`).then(this.callbackDataPaginate)
	  },
    callbackDataPaginate (response) {
      let responseData = response.body.dados
      this.table.currentPage = responseData.current_page
      this.table.data = responseData.data
      this.table.firstPageUrl = responseData.first_page_url
      this.table.from = responseData.from
      this.table.lastPage = responseData.last_page
      this.table.lastPageUrl = responseData.last_page_url
      this.table.nextPageUrl = responseData.next_page_url
      this.table.path = responseData.path
      this.table.perPage = responseData.per_page
      this.table.prevPageUrl = responseData.prev_page_url
      this.table.to = responseData.to
      this.table.total = responseData.total

      this.table.pages = []
      for (let i = 1; i <= (responseData.last_page); i++) {
        this.table.pages.push(i)
      }

      this.items = this.table.data

      this.table.load = false

      this.pagination = responseData
    },
    async loadData () {
      if ( !(this.inputs.name || this.inputs.cpf) ) {
        this.$toasted.show('Necessário informar Nome ou CPF.', {
            position: 'top-right',
          })
        document.getElementById('nome_aluno').focus()
        return
      }
      this.consulted = true
      this.table.load = true

      const filters = `funcao=${this.inputs.role}&periodoI=${this.inputs.initialPeriod}&periodoF=${this.inputs.finalPeriod}&status=${this.inputs.status}&name=${this.inputs.name}&cpf=${this.inputs.cpf}`
      this.filters = filters

      const consult = `${urlApiV2}/usuarios?${filters}`
      this.consult = consult

      this.$http.get(consult)
        .then(this.callbackDataPaginate)
        .catch(err => {
          this.$toasted.show(err, {
            position: 'top-right',
          })
        })
    },
    async loadRoles () {
      await this.$http.get(`${urlApiV2}/usuarios/funcoes`)
        .then(response => {
          this.selectRoles = response.body.dados.map(item => {
            return {
              value: item.id_funcao_usuario,
              text: item.funcao_usuario,
            }
          })
        })
        .catch(err => {
          this.$toasted.show('Erro ao carregar as funções de usuário.', {
            position: 'top-right',
          })
        })
    },
    detalhes: function (idUsuario) {
      let self = this
      this.$refs.smallModal.open()
      self.modal.load = true
      UsuariosController.getUsuarioById(idUsuario, function (response) {
        self.modal.conteudo = response.data.dados
        self.modal.load = false
      })
    },
    atualizaStatus: function (idUsuario, status) {
      let self = this
      UsuariosController.atualizaStatus(idUsuario, status, function () {
        self.loadData()
      })
    },
    paginaEdicao (idUsuario) {
      UsuariosController.paginaEdicao(idUsuario)
    },
    openModal () {
      this.$refs.fileModal.open()
    },
    async downloadFilePDF () {
      this.downloadPDFLoading = true

      if (this.table.data.length < 1) {
        this.$toasted.show('Consulte na tabela de usuários antes de baixar o PDF.', {
          position: 'top-right',
        })

        this.downloadPDFLoading = false

        return
      }

      await this.$http.get(`${urlApiV2}/usuarios/pdf?${this.filters}`)
        .then(response => {
          const pdf = `data:application/octet-stream;base64,${response.body.dados}`;

          const link = document.createElement('a');
          link.download = 'relatorio-usuarios.pdf';
          link.href = pdf;

          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
        })
        .catch(err => {
          this.$toasted.show('Erro ao fazer o download do relatório.', {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.downloadPDFLoading = false
        })
    },
    async downloadFileXLSX () {
      this.downloadXLSXLoading = true

      if (this.table.data.length < 1) {
        this.$toasted.show('Consulte na tabela de usuários antes de baixar o XLSX.', {
          position: 'top-right',
        })

        this.downloadXLSXLoading = false

        return
      }

      await this.$http.get(`${urlApiV2}/usuarios/xlsx?${this.filters}`)
        .then(response => {
          const csv = `data:text/csv;charset=utf-8,${response.body.dados}`
          const link = document.createElement('a')
          link.setAttribute('href', encodeURI(csv))
          link.setAttribute('download', 'relatorio-usuarios.xlsx')
          document.body.append(link)
          link.click()
          link.remove()
        })
        .catch(err => {
          console.log(err)
          this.$toasted.show('Erro ao fazer o download do relatório.', {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.downloadXLSXLoading = false
        })
    },
  }
}
</script>

<style type="scss" scoped>
  .form {
    fieldset {
      margin-bottom: 1rem;

      legend {
        font-size: 1.125rem;
      }
    }

    input {
      height: 2.375rem;
    }
  }

  .table thead tr {
		border-bottom: 0;
	}

  .seachButtons {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    gap: 1rem;
  }

	.buttons-td {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 0.25rem;
		flex-wrap: wrap;
	}

  .action-button {
    all: unset;
    cursor: pointer;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

		.fa {
      width: 35px;
      height: 35px;
      line-height: 15px;
      margin: 0px;
			color: white;
			padding: 10px;
      border-radius: 50%;
      box-shadow: black;
    }

		.fa-info {
      background-color: #ffc20e;
      border-color: #ffc20e;
    }

		.fa-lock {
      background-color: #dc3545;
      border-color: #dc3545;
    }

    .fa-unlock {
			background-color: #20c997;
			border-color: #20c997;
			box-shadow: black;
		}

    .fa-edit {
      background-color: #4ab2e3;
      border-color: #4ab2e3;
      box-shadow: black;
    }

		&:not(:disabled) {
			.fa-info:hover {
				background-color: #ffc30eaa;
			}

			.fa-lock:hover {
				background-color: #dc354683;
			}

      .fa-unlock:hover {
        background-color: #20c9967e;
      }

      .fa-edit:hover {
        background-color: #2c7da3;
      }
		}
  }

  .row-break {
    overflow-wrap: break-word;
  }

  .circle {
    width: .75rem;
    height: .75rem;
    border-radius: 50%;
    display: inline-block;
  }
</style>
